/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS_DISPLAY =
  'REFRESH_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS_DISPLAY';
export const SET_SELECTED_ZERO_URA = 'SET_SELECTED_ZERO_URA';
export const IS_LOADING_ZERO_URA = 'IS_LOADING_ZERO_URA';
export const GET_OUTSTANDING_DISPUTES_NUM_DAYS =
  'GET_OUTSTANDING_DISPUTES_NUM_DAYS';
export const REFRESH_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS =
  'REFRESH_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS';
